export default {
  primary: "#ed3338",
  secondary: "#ffce2a",
}
